import { FormDatas } from "../types/FormData";
import {api} from "./api"

export const fetchPublicFranchiseLocations = async () => {
    try {
        const response = await api.get('/public/franchise/locations');
        return response.data;
    } catch (error) {
        console.error('Error fetching franchise locations:', error);
        throw error;
    }
};

export const createInterest = async (payload: FormDatas): Promise<void> => {
    try {
      await api.post('/interests', payload); // Use the `api` instance for the POST request
    } catch (error: any) {
      console.error('Error creating interest:', error);
      throw new Error(error.response?.data?.message || 'An error occurred while creating the interest.');
    }
  };

  export const fetchAvailability = async (locationId: number, weekStartDate: string) => {
    try {
      const response = await api.get(`/locations/${locationId}/availability`, {
        params: { weekStartDate },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching availability:', error);
      throw new Error('Failed to fetch availability');
    }
  };
  